/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsMyGamesPublicAuthOptions, FxIdDomainSettingsMyGamesPublicAuthOptionsFromJSONTyped, FxIdDomainSettingsMyGamesPublicAuthOptionsToJSON, } from './FxIdDomainSettingsMyGamesPublicAuthOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsMyGamesPublicAuthOptions(json)) {
        return FxIdDomainSettingsMyGamesPublicAuthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsMyGamesPublicAuthOptions(value)) {
        return FxIdDomainSettingsMyGamesPublicAuthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGames.js.map